import styled from '@emotion/styled'

export const Cont = styled.div((props)=>({
    padding: '1rem',

    '.rt-tr-group':{
        cursor: props.d?'pointer':'inherit'
    },
    '.rt-tr-group:hover':{
        border: props.d?'solid 1px orange':'inherit'
    }
}));